import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ThemesService } from 'src/app/services/commonService/themes.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { NewTravelerFormComponent } from '../new-traveler-form/new-traveler-form.component';
import { DependentInformationFormComponent } from '../dependent-information-form/dependent-information-form.component';

@Component({
    selector: 'app-cam-tab-layout',
    templateUrl: './cam-tab-layout.component.html',
    styleUrls: ['./cam-tab-layout.component.scss'],
    imports: [NgIf, BreadcrumbsComponent, RouterOutlet, NewTravelerFormComponent, DependentInformationFormComponent]
})
export class CamTabLayoutComponent implements OnInit {
  renderer: boolean = true;
  constructor(private _ThemesService: ThemesService, private _CommonService: CommonService, private router:Router) {
    this._CommonService.componentRendererTrigger.subscribe(($: boolean) => {
      this.renderer = $;
    })
  }
  ngOnInit() {
    sessionStorage.removeItem('psq');
    this._ThemesService.setTheme('');
    
  }

  isTravelerSignup(): boolean {
  return this.router.url.includes('add-new-traveler');
}
isNewDependent(){
  return this.router.url.includes('dependent-information-form');
}

}
